import { Locale } from "@shared/enums/general"
import { CommunicationLogDetailResponse } from "@shared/zod/schemas/responses/communicationLog"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getById = async (id: string, locale: Locale): Promise<CommunicationLogDetailResponse> => {
  const resp = await axiosAuth({
    url: `/emails/${id}`,
    method: "get",
    params: { locale },
  })
  return resp.data
}
